/** Human-readable byte size, e.g. 1536 → "1.5 KB". null/undefined → "—". */
export function formatBytes(n) {
    if (n === null || n === undefined)
        return "—";
    if (n === 0)
        return "0 B";
    const units = ["B", "KB", "MB", "GB", "TB"];
    let v = n;
    let i = 0;
    while (v >= 1024 && i < units.length - 1) {
        v /= 1024;
        i += 1;
    }
    return `${v.toFixed(1)} ${units[i]}`;
}
